/* Roselle cart locale display adapter, 2026-09-19.
 * Display-only: no network calls, form inputs, cart properties, GPO config,
 * item keys, variant IDs, option values or prices are written.
 * Existing Indonesian property keys intentionally remain unchanged so Globo
 * can edit historical carts. label_<locale> is read, never used as a new key.
 * Snapshot fallback: GPO sets 1208655 / 1208649; missing he/tr/vi/pt-BR labels
 * and the scoped discount widget labels have explicit manual translations.
 */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.RJCartLocale = api;
    api.init(root);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var LOCALES = ["ar", "de", "en", "es", "fil", "fr", "he", "hi", "id", "it", "ja", "ko", "mn", "ms", "pt-BR", "ru", "th", "tr", "vi", "zh-CN", "zh-TW"];
  var FIELDS = {
  "stone": {
    "setId": "1208655",
    "elementId": "select-2",
    "storageKey": "Ukuran Batu Utama untuk Rangka",
    "labels": {
      "ar": "حجم الحجر الرئيسي للإطار",
      "de": "Hauptsteingröße für die Fassung",
      "en": "Main Stone Size For Setting",
      "es": "Tamaño de la piedra central para la montura",
      "fil": "Laki ng Pangunahing Bato para sa Setting",
      "fr": "Taille de la pierre centrale pour la monture",
      "he": "גודל האבן המרכזית לשיבוץ",
      "hi": "सेटिंग के लिए मुख्य पत्थर का आकार",
      "id": "Ukuran Batu Utama untuk Rangka",
      "it": "Dimensione della pietra centrale per la montatura",
      "ja": "枠用メインストーンサイズ",
      "ko": "세팅용 메인 스톤 크기",
      "mn": "Суулгацын гол чулууны хэмжээ",
      "ms": "Saiz Batu Utama untuk Tetapan",
      "pt-BR": "Tamanho da pedra central para a montagem",
      "ru": "Размер центрального камня для оправы",
      "th": "ขนาดพลอยเม็ดหลักสำหรับตัวเรือน",
      "tr": "Montür İçin Ana Taş Boyutu",
      "vi": "Kích thước đá chủ cho ổ nhẫn",
      "zh-CN": "戒托主石尺寸",
      "zh-TW": "空托的主石尺寸"
    }
  },
  "ring": {
    "setId": "1208649",
    "elementId": "select-2",
    "storageKey": "Ring Size",
    "labels": {
      "ar": "مقاس الخاتم",
      "de": "Ringgröße",
      "en": "Ring Size",
      "es": "Talla del anillo",
      "fil": "Laki ng singsing",
      "fr": "Taille de bague",
      "he": "מידת הטבעת",
      "hi": "अंगूठी का आकार",
      "id": "Ukuran cincin",
      "it": "Misura dell'anello",
      "ja": "リングサイズ",
      "ko": "반지 사이즈",
      "mn": "Бөгжний хэмжээ",
      "ms": "Saiz cincin",
      "pt-BR": "Tamanho do anel",
      "ru": "Размер кольца",
      "th": "ขนาดแหวน",
      "tr": "Yüzük ölçüsü",
      "vi": "Cỡ nhẫn",
      "zh-CN": "戒指尺寸",
      "zh-TW": "戒指尺寸"
    }
  },
  "engravingNeeded": {
    "setId": "1208649",
    "elementId": "switch-4",
    "storageKey": "Need Engraving ? ",
    "labels": {
      "ar": "هل تحتاج إلى نقش؟",
      "de": "Gravur benötigt?",
      "en": "Need Engraving ?",
      "es": "¿Necesitas grabado?",
      "fil": "Kailangan ng pag-ukit?",
      "fr": "Besoin de gravure ?",
      "he": "האם נדרשת חריטה?",
      "hi": "उत्कीर्णन की आवश्यकता है?",
      "id": "Perlu ukiran?",
      "it": "Hai bisogno di incisione?",
      "ja": "刻印は必要ですか？",
      "ko": "각인이 필요하신가요?",
      "mn": "Сийлбэр хэрэгтэй юу?",
      "ms": "Perlukan ukiran?",
      "pt-BR": "Deseja gravação?",
      "ru": "Нужна гравировка?",
      "th": "ต้องการแกะสลักหรือไม่?",
      "tr": "Gravür ister misiniz?",
      "vi": "Bạn có cần khắc chữ không?",
      "zh-CN": "需要刻字吗？",
      "zh-TW": "需要刻字？"
    }
  },
  "engraving": {
    "setId": "1208649",
    "elementId": "text-2",
    "storageKey": "Engraving For Ring",
    "labels": {
      "ar": "نقش للخاتم",
      "de": "Gravur für Ring",
      "en": "Engraving For Ring",
      "es": "Grabado para anillo",
      "fil": "Pag-ukit para sa singsing",
      "fr": "Gravure pour bague",
      "he": "חריטה לטבעת",
      "hi": "अंगूठी के लिए उत्कीर्णन",
      "id": "Ukiran untuk cincin",
      "it": "Incisione per anello",
      "ja": "リングの刻印",
      "ko": "반지 각인",
      "mn": "Бөгжний сийлбэр",
      "ms": "Ukiran untuk cincin",
      "pt-BR": "Gravação no anel",
      "ru": "Гравировка для кольца",
      "th": "การแกะสลักสำหรับแหวน",
      "tr": "Yüzük gravürü",
      "vi": "Nội dung khắc trên nhẫn",
      "zh-CN": "戒指刻字",
      "zh-TW": "戒指刻字"
    }
  },
  "expedite": {
    "setId": "1208655",
    "elementId": "switch-2",
    "storageKey": "Need expedited production?",
    "labels": {
      "ar": "هل تحتاج إلى إنتاج سريع؟",
      "de": "Benötigen Sie eine beschleunigte Produktion?",
      "en": "Need Expedited Production?",
      "es": "¿Necesita producción acelerada?",
      "fil": "Kailangan ng mabilis na produksyon?",
      "fr": "Besoin d'une production accélérée ?",
      "he": "האם נדרש ייצור מזורז?",
      "hi": "क्या आपको त्वरित उत्पादन की आवश्यकता है?",
      "id": "Perlu produksi dipercepat?",
      "it": "Hai bisogno di una produzione accelerata?",
      "ja": "特急製作が必要ですか？",
      "ko": "긴급 제작이 필요하신가요?",
      "mn": "Хурдасгасан үйлдвэрлэл хэрэгтэй юу?",
      "ms": "Perlukan pengeluaran dipercepatkan?",
      "pt-BR": "Precisa de produção expressa?",
      "ru": "Нужно ускоренное производство?",
      "th": "ต้องการการผลิตแบบเร่งด่วนหรือไม่?",
      "tr": "Hızlandırılmış üretim ister misiniz?",
      "vi": "Bạn có cần sản xuất gấp không?",
      "zh-CN": "需要加急生产吗？",
      "zh-TW": "需要加急製作嗎？"
    }
  }
};
  var WIDGET = {
  "ar": [
    "رمز الخصم",
    "تطبيق"
  ],
  "de": [
    "Rabattcode",
    "Anwenden"
  ],
  "en": [
    "Discount code",
    "Apply"
  ],
  "es": [
    "Código de descuento",
    "Aplicar"
  ],
  "fil": [
    "Discount code",
    "Ilapat"
  ],
  "fr": [
    "Code de réduction",
    "Appliquer"
  ],
  "he": [
    "קוד הנחה",
    "החלה"
  ],
  "hi": [
    "छूट कोड",
    "लागू करें"
  ],
  "id": [
    "Kode diskon",
    "Terapkan"
  ],
  "it": [
    "Codice sconto",
    "Applica"
  ],
  "ja": [
    "割引コード",
    "適用"
  ],
  "ko": [
    "할인 코드",
    "적용"
  ],
  "mn": [
    "Хөнгөлөлтийн код",
    "Хэрэглэх"
  ],
  "ms": [
    "Kod diskaun",
    "Guna"
  ],
  "pt-BR": [
    "Código de desconto",
    "Aplicar"
  ],
  "ru": [
    "Промокод",
    "Применить"
  ],
  "th": [
    "รหัสส่วนลด",
    "ใช้"
  ],
  "tr": [
    "İndirim kodu",
    "Uygula"
  ],
  "vi": [
    "Mã giảm giá",
    "Áp dụng"
  ],
  "zh-CN": [
    "优惠码",
    "应用"
  ],
  "zh-TW": [
    "優惠碼",
    "套用"
  ]
};

  var PROPERTY_SELECTOR = '.cart_meta_propertyList .t4s-product-details__item-label > strong, .t4s-cart_meta_propertyList .product-details__item-label > strong';
  var INPUT_SELECTOR = '.tdf_input_form .tdf_input_discount';
  var APPLY_SELECTOR = '.tdf_input_form [data-e="dcode_apply"]';
  var originalLabels = new WeakMap();

  function locale(value) {
    var code = String(value || '').trim().replace(/_/g, '-').toLowerCase();
    if (/^zh-(tw|hk|mo|hant)(-|$)/.test(code)) return 'zh-TW';
    if (code === 'zh' || /^zh-(cn|sg|hans)(-|$)/.test(code)) return 'zh-CN';
    if (code === 'pt' || /^pt-br(-|$)/.test(code)) return 'pt-BR';
    if (code === 'tl' || /^tl-/.test(code)) return 'fil';
    if (code === 'iw' || /^iw-/.test(code)) return 'he';
    if (code === 'in' || /^in-/.test(code)) return 'id';
    var base = code.split('-')[0];
    return LOCALES.indexOf(base) >= 0 ? base : 'en';
  }
  function cleanLabel(text) {
    return String(text || '').trim().replace(/[:：]\s*$/, '').trim();
  }
  function flatten(elements) {
    var list = [];
    (elements || []).forEach(function (element) {
      list.push(element);
      if (element.elements) list = list.concat(flatten(element.elements));
    });
    return list;
  }
  function elementFor(field, options) {
    var set = options && options[field.setId];
    return set && flatten(set.elements).find(function (e) { return e.id === field.elementId; });
  }
  function records(options) {
    return Object.keys(FIELDS).map(function (id) {
      var field = FIELDS[id];
      var source = elementFor(field, options);
      var labels = Object.assign({}, field.labels);
      var aliases = [field.storageKey].concat(Object.keys(labels).map(function (key) { return labels[key]; }));
      if (source) {
        aliases.push(source.label_on_cart, source.label);
        LOCALES.forEach(function (code) {
          var label = source['label_' + code];
          if (typeof label === 'string' && label.trim()) {
            aliases.push(label);
            // Snapshot corrects a pre-existing missing Arabic character.
            if (!(id === 'engravingNeeded' && code === 'ar' && label.trim() === 'ل تحتاج إلى نقش؟')) labels[code] = label.trim();
          }
        });
      }
      return {id: id, labels: labels, aliases: aliases.filter(Boolean).map(cleanLabel)};
    });
  }
  function lookup(label, code, options) {
    var key = cleanLabel(label);
    var match = records(options).find(function (record) { return record.aliases.indexOf(key) >= 0; });
    return match ? match.labels[locale(code)] : null;
  }
  function updateProperty(node, code, index) {
    var text = node.textContent;
    var previous = originalLabels.get(node);
    var original = previous && text === previous.rendered ? previous.original : text;
    var key = cleanLabel(original);
    var match = index.find(function (record) { return record.aliases.indexOf(key) >= 0; });
    if (!match) return;
    var suffix = /[:：]\s*$/.test(original) ? ':' : '';
    var next = match.labels[code] + suffix;
    originalLabels.set(node, {original: original, rendered: next});
    if (text !== next) node.textContent = next;
  }
  function updateApply(node, label) {
    // Keep widget listeners, children/spinners, state and discount behavior.
    if (node.disabled || node.getAttribute('aria-busy') === 'true' ||
        /(^|\s)(loading|is-loading|tdf_loading)(\s|$)/.test(node.className || '')) return;
    var textNode = Array.prototype.find.call(node.childNodes || [], function (child) {
      return child.nodeType === 3 && child.nodeValue.trim();
    });
    if (textNode && textNode.nodeValue !== label) textNode.nodeValue = label;
  }
  function apply(doc, code, options) {
    code = locale(code);
    var index = records(options);
    doc.querySelectorAll(PROPERTY_SELECTOR).forEach(function (node) { updateProperty(node, code, index); });
    doc.querySelectorAll(INPUT_SELECTOR).forEach(function (node) {
      var placeholder = WIDGET[code][0];
      if (node.getAttribute('placeholder') !== placeholder) node.setAttribute('placeholder', placeholder);
    });
    doc.querySelectorAll(APPLY_SELECTOR).forEach(function (node) { updateApply(node, WIDGET[code][1]); });
  }
  function init(win) {
    var doc = win.document;
    if (!doc || win.__rjCartLocaleInstalled) return;
    win.__rjCartLocaleInstalled = true;
    var scheduled = false;
    var run = function () {
      scheduled = false;
      apply(doc, (win.Shopify && win.Shopify.locale) || doc.documentElement.lang || 'en',
        win.GPOConfigs && win.GPOConfigs.options);
    };
    var schedule = function () {
      if (scheduled) return;
      scheduled = true;
      (win.requestAnimationFrame || win.setTimeout).call(win, run);
    };
    var start = function () {
      run();
      if (win.MutationObserver && doc.body) {
        var observer = new win.MutationObserver(schedule);
        observer.observe(doc.body, {subtree: true, childList: true, characterData: true});
        observer.observe(doc.documentElement, {attributes: true, attributeFilter: ['lang']});
      }
      ['gpoRenderCompleted', 'cart:updated', 'cart:rerendered', 't4s:cart:updated', 'rj:cart:updated'].forEach(function (event) {
        doc.addEventListener(event, schedule);
      });
    };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
  }
  return {version: '2026-09-19.2', locales: LOCALES.slice(), normalizeLocale: locale,
    lookup: lookup, apply: apply, init: init,
    selectors: {property: PROPERTY_SELECTOR, input: INPUT_SELECTOR, apply: APPLY_SELECTOR}};
});
